const ssoApiUrl = process.env.REACT_APP_SSO_API_URL

export const UNAUTH_CLIENT_PATHS = {
  EXCHANGE_ID_TOKEN: 'auth/google_login',
  EXCHANGE_OMNI_TOKEN: 'auth/token'
} as const

type unauthClientPath = (typeof UNAUTH_CLIENT_PATHS)[keyof typeof UNAUTH_CLIENT_PATHS]

const EXCHANGE_OMNI_TOKEN_GRANT_TYPE = 'omni_token'

interface unauthClientBasePayload {
  path: unauthClientPath
}

interface ExchangeIdTokenPayload extends unauthClientBasePayload {
  path: typeof UNAUTH_CLIENT_PATHS.EXCHANGE_ID_TOKEN
  idToken: string
}

interface ExchangeOmniTokenPayload extends unauthClientBasePayload {
  path: typeof UNAUTH_CLIENT_PATHS.EXCHANGE_OMNI_TOKEN
  omniToken: string
  clientId: string
}

type unauthClientPayload = ExchangeIdTokenPayload | ExchangeOmniTokenPayload

export const unauthClient = async (input: unauthClientPayload): Promise<unknown> => {
  if (!ssoApiUrl) {
    throw new Error('REACT_APP_SSO_API_URL is not defined')
  }

  const { path } = input

  let bodyObject: Record<string, string> = {}

  switch (path) {
    case UNAUTH_CLIENT_PATHS.EXCHANGE_ID_TOKEN:
      bodyObject = {
        id_token: input.idToken
      }
      break
    case UNAUTH_CLIENT_PATHS.EXCHANGE_OMNI_TOKEN:
      bodyObject = {
        client_id: input.clientId,
        grant_type: EXCHANGE_OMNI_TOKEN_GRANT_TYPE,
        omni_token: input.omniToken
      }
      break
    default:
      throw new Error(`Unknown unauthenticated client path: ${path}`)
  }

  const requestInit = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(bodyObject)
  }

  const response = await fetch(`${ssoApiUrl}/${path}`, requestInit)

  if (!response.ok) {
    const errorData = (await response.json().catch(() => ({ message: 'Failed to parse error response' }))) as unknown

    const message =
      errorData && typeof errorData === 'object' && 'message' in errorData && typeof errorData.message === 'string'
        ? errorData.message
        : JSON.stringify(errorData)
    throw new Error(message)
  }

  return response.json()
}
